
import React from 'react';
export default function Blog008() {
  return (
    <section>
    <article>
      <h2>8. 08-18-2022</h2>
      <h3>Learning javascript</h3>
      <p> 
        Hello everyone. <br />
I spent a bit of time yesterday working on uploading the weekly vlog. I would like to keep these vlog videos short, since I am recording them weekly, there is not an extensive amount of content to go over. This is actually why I might start staggering out the frequency of these videos. In layman's terms, don't be surprised if I skip a weekly vlog, one of these weeks. I would like to spend more time creating projects and a bit less time preparing and presenting. <br /><br />
Lets take a minute to talk about hardware. Yesterday, I also spent a bit of time moving desks and computers. I set up the following work spaces. <br /><br />
I have set up a Linux Mint Thinkcentre pc on a metal rack in the basement. This workspace is primarily used for watching tutorial videos and tasks unrelated to coding like recording music or FL studio using WINE and PlayOnLinux. I like to use the basement for short breaks, walking up and down the stairs is an easy way to increase blood circulation in the legs. Which leads me to the 2nd and current primary work space at the top of the stairs. <br /><br />
This Windows10, GTX1050, workspace has a 32 inch monitor and a standard monitor on a standard computer desk. I have installed the webcam and usb microphone to this pc for recording videos or pair programming.  <br /><br />
In the kitchen I have a laptop with Linux Mint. This is great for on the go, or watching tutorials on a lunch break. <br /><br />
Upstairs in the office is my beast computer, with an RTX 2060 and 40GB of ram. I am currently not using this room due to temperature control issues. What I am trying to say is, I will be using this office as my primary work space next month. The four computers of Mordor.  <br /><br />
Before I moved the computers and furniture I backed up all the files to multiple usb sticks and external hard drives. With back-ups stored I cleaned up some files and folders while increasing maximum storage space.
I was just thinking since this is a technical blog, I should go over the hardware I am using to complete these technical tasks. With that out of the way, I can talk a bit about my progress with development. <br /><br />
I am working on the Web Dev Simplified tutorial: How to Code Snake. I plan on restarting this one fresh from the beginning. I also plan on working through the ‘Learn Javascript by Building 7 Games - Full Course.’ from the freeCodeCamp.org Youtube channel. I will build them in the same order as the course. I’d like to mention that I started the ‘rock paper scissors’ game a few weeks ago, and ran into a problem. I couldn't fix it at the time. Even when I downloaded the source-code, the problem was there as well! I am guessing I applied a setting that prevented proper functionality. Whatever the case may have been, I feel more confident with my problem solving skills now. I would like to take a second shot at the ‘rock paper scissors’ game, and then build the rest of the games in the tutorial. 
<br /><br />
To sum it all up, I moved things around in my house, I have new work spaces, and I am going to work on the above mentioned tutorials. I have no plans of building any other projects this week. I really want to extract some core concepts from these tutorials. Thank you for taking the time to read this blog, I’ll show you something cool next time. <br /><br /> -Eric


      </p> 
    </article>

    <h4>Links</h4>
    <br />
    <ul>
      <li>
        <a
          href="https://www.youtube.com/watch?v=hHKFmBqIjoU&list=PLce5_YZyrUw7dNEL7F1T4kxAp0mMuattO"
          title="Vlog"
          rel="noopener noreferrer" 
          target="_blank"
        >
          <strong><p>THE VLOG - Video Blog Series</p></strong></a
        >
      </li>
      
      <li>
        <a
          href="http://erpolley.com"
          title="Check out my website"
          rel="noopener noreferrer" 
          target="_blank"
        >
          <strong><p>Check out my website</p></strong></a
        >
      </li>
    </ul>
  </section>
  )
}
